module.exports = __webpack_public_path__ + "static/img/18.d6e4099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/18.png
// module id = HYe/
// module chunks = 5